import { useState, type ReactNode } from "react";
import { cn } from "@/lib/cn";
import styles from "./ui.module.css";

export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Tooltip({ content, children, className }: TooltipProps) {
  const [open, setOpen] = useState(false);
  return (
    <span
      className={cn(styles.tooltipWrap, className)}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onFocus={() => setOpen(true)}
      onBlur={() => setOpen(false)}
    >
      {children}
      {open ? (
        <span role="tooltip" className={styles.tooltip}>
          {content}
        </span>
      ) : null}
    </span>
  );
}
